import React from 'react';

/**
 * Red de seguridad de las páginas públicas (sin sesión).
 *
 * Cuando un componente lanza durante el render, React desmonta el árbol
 * completo y deja `#root` vacío. Con el tema oscuro eso es una «pantalla en
 * negro»: ni mensaje, ni botón, ni forma de saber si el problema es el
 * servidor, la red o el navegador del que está mirando.
 *
 * En la página de descarga del agente eso es especialmente malo, porque la
 * abre gente que no tiene cuenta en el CMDB y no puede preguntar dentro de la
 * aplicación. Aquí, si algo falla, se ve el error y un enlace para recargar.
 */
export default class PublicErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Sin esto, el fallo solo se ve en la consola del que lo sufre.
    console.error('[pagina-publica] error de render:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const mensaje = String(this.state.error?.message || this.state.error || 'Error desconocido');
    return (
      <div className="ad-page">
        <div className="ad-wrap" style={{ paddingTop: 56 }}>
          <h1 className="ad-h1">No se pudo cargar esta página</h1>
          <p className="ad-sub">
            Ha fallado algo al pintar la pantalla. No afecta a tu equipo ni a la CMDB:
            recarga y, si vuelve a pasar, pasa este texto a quien administre el CMDB.
          </p>
          <pre
            className="ad-code"
            style={{ whiteSpace: 'pre-wrap', padding: 14, borderRadius: 10 }}
          >
            {mensaje}
          </pre>
          <p style={{ marginTop: 18 }}>
            <a className="ad-link" href={this.props.reloadHref || window.location.href}>
              Recargar la página
            </a>
          </p>
        </div>
      </div>
    );
  }
}
